import styled, { css } from 'styled-components';

import { Button } from '@xing-com/button';
import { Marker as BaseMarker } from '@xing-com/marker';
import { ProfileImage } from '@xing-com/profile-image';
import { StarRating } from '@xing-com/star-rating';
import {
  spaceXS,
  spaceS,
  spaceM,
  spaceL,
  xdlColorTextSecondary,
} from '@xing-com/tokens';
import { Headline, BodyCopy } from '@xing-com/typography';

import { PeakAndPop as PeakAndPopBase } from './peak-and-pop';

const PeakAndPop = styled(PeakAndPopBase)`
  align-items: center;
`;

const Logo = styled(ProfileImage)`
  margin: 0 auto ${spaceL} auto;
`;

const Title = styled(Headline)`
  margin: 0;
  text-align: center;
  word-break: break-word;
`;

const Marker = styled(BaseMarker)`
  width: fit-content;
  margin: ${spaceL} auto 0 auto;
  padding: ${spaceS};
  flex-shrink: 0;
`;

const About = styled.div`
  margin-top: ${spaceL};
`;

const AboutHeadline = styled(Headline)`
  margin-bottom: ${spaceS};
`;
const AboutSummary = styled(BodyCopy)`
  margin: 0;
`;

const ActionContainer = styled.div`
  margin-top: ${spaceM};
`;

const Action = styled(Button)``;

const Kununu = css`
  display: flex;
  align-items: center;
  flex-direction: column;
  margin-top: ${spaceL};
  color: inherit;
  text-decoration: none;

  &:hover {
    text-decoration: none;
  }
`;

const KununuAnchor = styled.a<{ href: string }>`
  ${Kununu}
`;

const KununuDiv = styled.div`
  ${Kununu}
`;

const KununuRating = styled.div`
  display: flex;
`;
const KununuRatingStars = styled(StarRating)``;
const KununuRatingValue = styled(BodyCopy)`
  margin: 0 ${spaceXS} 0 0;
  font-weight: bold;
`;
const KununuLabel = styled(BodyCopy)`
  margin: 0;
  font-weight: bold;
`;

const KununuReviewsCount = styled(BodyCopy)`
  margin-top: ${spaceXS};
  color: ${xdlColorTextSecondary};
`;

export default {
  PeakAndPop,
  Logo,
  Title,
  Marker,
  About,
  AboutHeadline,
  AboutSummary,
  ActionContainer,
  Action,
  Kununu,
  KununuRating,
  KununuRatingStars,
  KununuLabel,
  KununuRatingValue,
  KununuReviewsCount,
  KununuAnchor,
  KununuDiv,
};
